export default "__VITE_ASSET__DIriorZh__"